import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import useStorage from '../hooks/useStorage';
import Header from '../components/header';

export default function ConfigContainer() {
  const navigate = useNavigate();
  const { env, setEnv, host, setHost, user, setUser, password, setPassword, operator, setOperator, save } =
    useStorage();

  function onSubmit(e) {
    e.preventDefault();
    save();
    navigate('/status');
  }

  return (
    <>
      <Header />
      <div className="container">
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3" controlId="formConfigOperator">
            <Form.Label>Operator</Form.Label>
            <Form.Control
              value={operator}
              onChange={(e) => setOperator(e.target.value)}
              type="text"
              placeholder="Enter operator"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formConfigEnv">
            <Form.Label>Environment</Form.Label>
            <Form.Select value={env} onChange={(e) => setEnv(e.target.value)}>
              <option>prod</option>
              <option>test</option>
              <option>stage</option>
              <option>dev</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formConfigHost">
            <Form.Label>Host</Form.Label>
            <Form.Control value={host} onChange={(e) => setHost(e.target.value)} type="text" placeholder="Enter host" />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formConfigUser">
            <Form.Label>Username</Form.Label>
            <Form.Control value={user} onChange={(e) => setUser(e.target.value)} type="text" placeholder="Username" />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formConfigPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Password"
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Go
          </Button>
        </Form>
      </div>
    </>
  );
}
